import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { DialogProvider as DaxDialogProvider } from '@global-dax-ad-platform/dax-components';
import { StylesProvider, ThemeProvider } from '@material-ui/core';
import { createRoot } from 'react-dom/client';
import 'styles/index.css';
import { BrowserRouter } from 'react-router';

import App from 'components/App/App';
import Snackbar from 'components/Snackbar';
import { AuthProvider } from 'context/AuthProvider/AuthProvider';
import DialogProvider from 'context/DialogProvider/DialogProvider';
import { FilterProvider } from 'context/FilterProvider/FilterProvider';
import RefreshProvider from 'context/RefreshProvider/RefreshProvider';
import { SearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import SnackbarProvider from 'context/SnackbarProvider/SnackbarProvider';
import ImportDialog from 'features/Import/components/ImportDialog/ImportDialog';
import { makeServer } from 'mocks/server/server';
import styles from 'styles';
import { msalConfig } from 'utils/auth/msalConfig';
import { USE_MOCK_SERVER } from 'utils/environmentVariables';

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

if (USE_MOCK_SERVER === 'true') {
  makeServer();
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <MsalProvider instance={msalInstance}>
    <AuthProvider>
      <BrowserRouter>
        <StylesProvider jss={styles.plugins}>
          <ThemeProvider theme={styles.theme}>
            <RefreshProvider>
              <SearchParamsProvider>
                <SnackbarProvider>
                  <FilterProvider>
                    <DialogProvider>
                      <DaxDialogProvider>
                        <App />
                        <ImportDialog />
                        <Snackbar />
                      </DaxDialogProvider>
                    </DialogProvider>
                  </FilterProvider>
                </SnackbarProvider>
              </SearchParamsProvider>
            </RefreshProvider>
          </ThemeProvider>
        </StylesProvider>
      </BrowserRouter>
    </AuthProvider>
  </MsalProvider>
);
